export const getMetaContentByName = (name) => {
  const el = document.querySelector(`meta[name="${name}"]`)
  return el ? el.getAttribute("content") : null
}

export const getSupportedLanguageCodes = () => {
  const csv = getMetaContentByName("supported-languages")
  if (!csv) return ["en", "es"]
  return csv.split(",").map((c) => c.trim()).filter(Boolean)
}

export const getDestinationLanguages = () => {
  return getSupportedLanguageCodes().filter((c) => c !== "en")
}

const WEGLOT_API_KEY = "wg_6d071f80c672beecd567d9d3f7b6784b1"
export const getWeglotApiKey = () => WEGLOT_API_KEY

export const getWeglotDefaults = () => ({
  api_key: getWeglotApiKey(),
  excluded_blocks: [{value: ".no-translate"}],
  hide_switcher: true,
  auto_switch: true,
  original_language: "en"
})

export const getLanguageDisplayName = (code) => {
  if (window.Weglot && typeof window.Weglot.getLanguageName === "function") {
    try { return window.Weglot.getLanguageName(code) } catch (_) {}
  }
  const fallback = {
    en: "English",
    es: "Español",
    fr: "Français",
    zh: "中文 (Chinese)",
    tl: "Tagalog",
    vi: "Tiếng Việt (Vietnamese)",
    ht: "Kreyòl Ayisyen (Haitian Creole)",
    br: "Português (Brasil)",
    ar: "العربية (Arabic)",
    hmn: "Hmoob (Hmong)",
    ko: "한국어 (Korean)"
  }
  return fallback[code] || code
}

